import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

interface ILinkProps {
  bold?: boolean
}

export const CustomLink = styled(Link)<ILinkProps>`
  font-size: 14px;
  color: #4094fe;
  font-weight: ${props => (props.bold ? 600 : 400)};
`
